import React from 'react';
import {Box } from '@chakra-ui/react';
import {useSelector } from "react-redux";
import CustomTablePage2 from './CustomTablePage2';


const ExamTimeTableDetails = () => {
    const timeTableData =  useSelector((state) => state?.examTimeTable?.examTimeTableDetails);
    // console.log(timeTableData);

    const tableProps = {
        data: timeTableData?.tableContent,
        title: {
            subjectCode: "Subject Code",
            examDate: "Exam Date",
            startTime: "Start Time",
            endTime:"End Time",
          
        },
        dataKeys: [
          "subjectCode",
          "examDate",
          "startTime",
          "endTime",
        ],
        showPagination:false,
        transformRow: (item) => ({
            subjectCode :item && <Box style={{cursor:'pointer'}}>{item?.subjectCode}</Box>,
            examDate:item && <Box style={{cursor:'pointer'}}>{item?.examDate}</Box>,
            startTime:item && <Box style={{cursor:'pointer'}}>{item?.startTime}</Box>,
            endTime:item && <Box style={{cursor:'pointer'}}>{item?.endTime}</Box>,
        }),
      };

  return (
    <>
        <CustomTablePage2 {...tableProps} />
    </>
  )
}

export default ExamTimeTableDetails;